import React from 'react';

import ComingSoon from '../../ComingSoon';

export const InsightsDetail = () => (
    <>
        <ComingSoon></ComingSoon>
    </>
);
